import { gql } from '@apollo/client';

export const GET_LIST_OF_EQUIPMENT_REVENUE_BY_VO_ID = gql`
  query EquipmentRevenuesByVOId($id: ID, $VOId: ID) {
    equipmentRevenues: equipments(id: $id, VOId: $VOId) {
      id: equipmentId
      make
      year
      model
      retailPrice
      wholesaleCost
      salesCommissionPercent
      saleRep(VOId: $VOId) {
        id
        fullName
      }
    }
  }
`;
